import { Instance } from 'mobx-state-tree';
import model from './model';

const CertificateUserMetadataStore = model;

export interface ICertificateUserMetadataStore extends Instance<typeof CertificateUserMetadataStore> {}

export default CertificateUserMetadataStore;
